import React from "react";

import { getConnectivityLogosComponentData } from "../data/components-ourpartners.data";
import WpImageFluid from "./WpImageFluid";
import ContainerWide from "./ContainerWide";
import { Container } from "react-bootstrap";
import { VectorBackground } from "./VectorBackground";
import ImagesGallery from "./ImagesGallery";

const chunkLogos = (logos, rows) => {
    if (!logos || rows < 1) return [];
    const result = [];
    const chunkSize = Math.ceil(logos.length / rows);
    for (let i = 0; i < logos.length; i += chunkSize) {
        result.push(logos.slice(i, i + chunkSize));
    }
    return result;
};

const ConnectivityLogos = ({
    header,
    text,
    logos,
    variant,
    numberOfRowsDesktop,
    numberOfColumnsMobile,
    className,
    containerClassName,
    galleryClassName,
    logosAlign,
    ...rest
}) => {
    if (!logos) {
        const compData = getConnectivityLogosComponentData();
        logos = compData.wp.mdaThemeOptions.themeSettings.connectivity.logos;
    }

    if (!logos || logos.length === 0) return null;

    const rows =
        numberOfRowsDesktop > 0
            ? chunkLogos(logos, numberOfRowsDesktop)
            : [logos];

    return (
        <ContainerWide
            className={`connectivity-logos ${
                variant ? `-variant-${variant}` : ""
            } ${className || ""}`}
        >
            <div className="connectivity-logos__container">
                {variant === "dark" && <VectorBackground />}
                <Container className="connectivity-logos__box">
                    {header && (
                        <h2
                            className="connectivity-logos__header"
                            dangerouslySetInnerHTML={{ __html: header }}
                        />
                    )}
                    {/* <div
                        className={`connectivity-logos__grid ${
                            galleryClassName || ""
                        }`}
                    >
                        {rows.map((row, rowIndex) => (
                            <div
                                className="connectivity-logos__row"
                                key={`row-${rowIndex}`}
                            >
                                {row.map((logo, logoIndex) => (
                                    <div
                                        className="connectivity-logos__logo"
                                        key={`logo-${rowIndex}-${logoIndex}`}
                                    >
                                        <WpImageFluid
                                            image={logo.image}
                                            className="connectivity-logos__img"
                                        />
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div> */}
                    <ImagesGallery
                        className={`${galleryClassName || ""}`}
                        images={logos?.map((logo) => logo.image)}
                        style={{
                            justifyContent: logosAlign || "center",
                            alignItems: "center",
                            "--numberOfRowsDesktop": numberOfRowsDesktop,
                            "--numberOfColumnsMobile": numberOfColumnsMobile,
                        }}
                    />
                    {text && (
                        <p
                            className="connectivity-logos__text"
                            dangerouslySetInnerHTML={{ __html: text }}
                        />
                    )}
                </Container>
            </div>
        </ContainerWide>
    );
};

export default ConnectivityLogos;
